import { cloneDeep } from '@/setup/lodash';
import { clearObject } from '@/service/helper';
import { useRouter, useRoute } from 'vue-router';
import * as qs from 'qs';

export function useUpdateUrl() {
  const router = useRouter();
  const route = useRoute();

  const updateGetParams = (data = {}) => {

    const dataLoc = clearObject(data);

    // router.replace({
    //   path: route.path,
    //   query: dataLoc,
    //   state: { ignoreNavGuard: true } 
    // });

    window.history.replaceState(window.history.state, '', `${window.location.origin}${window.location.pathname}?${calculateUrl(dataLoc)}`);
  };

  const calculateUrl = (hash: any) => {
    return qs.stringify(hash, { encode: false });
  };

  const getParseParams = (hash: any, protectedKey: string[] = []) => {
    const _data = cloneDeep(route.query);
    /*
    * убираем лишние ключи для того чтобы не сломалась система, при изминении url)
    * */
    if (protectedKey.length !== 0) {
      for (const key in _data) {
        if (!(protectedKey.indexOf(key) + 1)) {
          delete _data[key];
        }
      }
    }

    return _data;
  };

  return {
    updateGetParams,
    getParseParams,
  };
};
